module.exports = __webpack_public_path__ + "img/PL09464.a61a8dc5.png";